module.exports = __webpack_public_path__ + "img/color_block_11.0198f658.svg";